import { useEffect, useState } from "react";
import "./EmailMassivePopup.scss";
import useNotification from "../../../hooks/notification.hook";
import OrganizationsPickerTable from "../../utils/OrganizationsPickerTable";
import { useOrganizationPicker } from "../../../context/organizations-picker.context";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import TextareaInput from "../../input/TextareaInput";
import { sharePlanEmailMassive } from "../../../services/admin.service";
import WizardModal, {
	WizardBody,
	WizardFooter,
	WizardHeader,
	WizardStepContent,
} from "../wizard/WizardModal";

export default function EmailMassiveModal({ open, setOpen, loadingData }) {
	const schema = yup.object().shape({
		mail_subject: yup.string().required(),
		mail_body: yup.string().required(),
	});

	const {
		register,
		setValue,
		clearErrors,
		handleSubmit,
		formState: { errors },
	} = useForm({ resolver: yupResolver(schema) });

	const [loading, setLoading] = useState(false);

	const { setFilteredList, organizations, setFilterType, selectedEntity, setSelectedEntity } =
		useOrganizationPicker();

	const { openNotification, helperErrorNotification, formErrorNotification } = useNotification();

	useEffect(() => {
		if (open) {
			setSelectedEntity([]);
			setFilteredList(organizations);
			setFilterType([]);
			setValue("mail_subject", "");
			setValue(
				"mail_body",
				"Gentile cliente, \n\n\n Con l'occasione si porgono i più cordiali saluti."
			);
			clearErrors();
		}
	}, [open]);

	/**
	 * Form Handler
	 * @param {form modal} data
	 */
	async function sendEmailHandler(data) {
		if (selectedEntity.length > 0) {
			if (!loading) {
				setLoading(true);

				const body = {
					...data,
					organization_plan_ids: selectedEntity.map((el) => el.organization_plans[0].id),
				};

				// copy conf
				sharePlanEmailMassive(
					body,
					() => {
						openNotification({
							text: "Operazione completata con successo!",
							status: "success",
						});
						setLoading(false);
						setOpen(false);
					},
					(err) => {
						helperErrorNotification(err);
						setLoading(false);
					}
				);
			}
		}
	}

	return (
		<WizardModal
			open={open}
			setOpen={setOpen}
			disableClose={loading}
			className="email_massive_plan_popup"
			stepClassName={{ 2: "form_wizard" }}
		>
			{/* Step 1 */}
			<WizardStepContent stepIndex={1}>
				<WizardHeader
					title="Invio massivo piani"
					description="Seleziona gli enti di destinazione"
					className="divide_header"
				/>

				<WizardBody stepIndex={1}>
					<OrganizationsPickerTable loadingData={loadingData} />
				</WizardBody>

				<WizardFooter className="divide_footer" disableNext={selectedEntity.length === 0} />
			</WizardStepContent>

			{/* Step 2 */}
			<WizardStepContent stepIndex={2}>
				<WizardHeader
					title="Invio massivo piani"
					description="Compila contenuto email"
					showBackButton
					className="divide_header"
				/>

				<WizardBody stepIndex={2}>
					<div className="py-2">
						<form
							id="massive-email-form-popup"
							className="main_form_email"
							onSubmit={handleSubmit(sendEmailHandler, formErrorNotification)}
							noValidate
						>
							<div className="global_form_landing">
								{/* Name extended */}
								<div className="base">
									<div className="wrap_input_landing">
										<label htmlFor="email-massive-obj" className="label_input">
											Oggetto
										</label>
										<input
											className={`landing big${errors.mail_subject ? " err" : ""}`}
											id="email-massive-obj"
											type="text"
											{...register("mail_subject")}
										/>
									</div>
								</div>

								{/* Name extended */}
								<div className="base">
									<div className="wrap_input_landing">
										<label htmlFor="email-massive-body" className="label_input">
											Messaggio
										</label>
										<TextareaInput
											className={`big${errors.mail_body ? " err" : ""}`}
											{...register("mail_body")}
											id={`email-massive-body`}
										/>
									</div>
								</div>
							</div>
						</form>
					</div>
				</WizardBody>

				<WizardFooter
					className="divide_footer"
					enableHandler={false}
					nextButtonText="Invia email"
					buttonProps={{ form: "massive-email-form-popup", type: "submit" }}
					isLoading={loading}
				/>
			</WizardStepContent>
		</WizardModal>
	);
}
